<div class="container">
  <h3>
    Change Password
  </h3>
  <hr />
  <form class="form-horizontal" [formGroup]="changePasswordForm" (ngSubmit)="changePassword(changePasswordForm.value)">
    @if (Message) {
    <div class="row message" [ngClass]="{'label-success':!Error,'label-danger':Error}">
      {{Message}}
    </div>
    }
    <div class="row">
      <div class="form-group">
        <div class="col-lg-3"><label>Current Password</label></div>
        <div class="col-lg-9">
          <input type="password" class="form-group" formControlName="currentPassword" name="currentPassword" id="currentPassword" />
          @if(changePasswordForm.controls.currentPassword.invalid && changePasswordForm.controls.currentPassword.touched) {
          <em class="text-danger">Required!</em>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="col-lg-3"><label>New Password</label></div>
        <div class="col-lg-9">
          <input type="password" class="form-group" formControlName="password" name="password" />
          @if(changePasswordForm.controls.password.errors && changePasswordForm.controls.password.errors['required'] && changePasswordForm.controls.password.touched) {
          <em class="text-danger">Required!</em>
          }
          @if(changePasswordForm.controls.password.errors && changePasswordForm.controls.password.errors['pattern']) {
          <em class="text-danger">The password must contain uppercase, lowercase, numeric, one of [ #$^+=!*()&#64;%&)] , and be at least 8 characters!</em>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="col-lg-3"><label>Confirm Password</label></div>
        <div class="col-lg-9">
          <input type="password" class="form-group" formControlName="confirmPassword" name="confirmPassword" />
          @if(!isMatch() && changePasswordForm.controls.confirmPassword.touched) {
          <em class="text-danger">The password doesn't match!</em>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="col-lg-3">
        </div>
        <div class="col-lg-9 no-left-padding">
          <input type="submit" value="Submit" class="btn btn-success" [disabled]="!IsValid()" />
        </div>
      </div>
    </div>
  </form>
</div>
